import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
    Box, TablePagination, Card, Tabs, Tab, Grid, Typography, MenuItem, Select, TextField,
    FormControl, InputLabel, Button, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Paper, Table, CircularProgress, Container, InputAdornment
} from "@mui/material";
import { makeApiRequest } from '../../../utils/api';
import { trimSeconds, formatTimeToHoursMinutes, formatDuration, formatDate, generateDateHeaders } from '../../../helpers/timeHelper';
import axios from 'axios';
import { getLocationList, getLocation } from '../../../helpers/commonHelper';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import DownloadIcon from '@mui/icons-material/Download';
import { width } from "@mui/system";
import { jsPDF } from "jspdf";
import { Search } from "@mui/icons-material";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import "jspdf-autotable";
import * as XLSX from 'xlsx';
import { formatMonth } from '../../../helpers/timeHelper';
import GridOnIcon from '@mui/icons-material/GridOn';

const env = process.env.REACT_APP_ENV || 'development';

const ViewStaffTask = () => {
    const todayDate = new Date().toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });
    const [month, day, year] = todayDate.split('/');
    const formattedDate = `${year}-${month}-${day}`;
    var today_date = formattedDate;

    const control = localStorage.getItem('control')
    const userLocation = getLocation(localStorage.getItem('userLocation'))
    const userName = (control != 1 && control != 4) ? localStorage.getItem('userid') : null

    const [value, setValue] = useState('today');
    const [location, setLocation] = useState("All Locations");
    const [staff, setStaff] = useState("");
    const [staffName, setStaffName] = React.useState('');
    const [search, setSearch] = React.useState('');
    const [startDate, setStartDate] = useState(today_date);
    const [endDate, setEndDate] = useState(today_date);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [learningData, setLearningData] = React.useState([]);
    const [staffData, setStaffData] = React.useState([]);
    const [locations, setLocations] = useState([]);
    const [staffList, setStaffList] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [sortConfig, setSortConfig] = useState({
        key: null,
        direction: 'asc'
    });
    const [totalRecords, setTotalRecords] = useState(0);
    const [hasSubmitted, setHasSubmitted] = useState(false);

    useEffect(() => {
        listLocation()

        if (value == 'today') {
            if (control != 1) {
                setLocation(userLocation);
                setStaffName(userName);
                fetchStaffData();
                setHasSubmitted(true);
            }
            else {
                fetchStaffData();
            }
        }
    }, [value, location, staffName]);

    const listLocation = () => {
        const locationList = getLocationList();
        setLocations(locationList);
    }
    const fetchStaffDataToday = async () => {
        try {
            setLoading(true);
            setError(null);
            setHasSubmitted(true);

            const response = await makeApiRequest('post', '/api/learning/staff', {
                token: localStorage.getItem('authToken'),
                data: {
                    start_date: formattedDate,
                    end_date: formattedDate,
                    location: userLocation ? userLocation : location,
                    name: (control == 2 && userName) ? userName : staffName,
                },
                page: page + 1,
                per_page: rowsPerPage
            });

            if (response.status === 'success') {
                setLearningData(response.data.data);


                const pagination = response.data.pagination || {};
                setTotalPages(pagination.last_page || Math.ceil(response.data.data.length / rowsPerPage));
                setTotalRecords(pagination.total || response.data.data.length);
            } else {
                setLearningData([]);
                throw new Error('Invalid data received');
            }
        } catch (err) {
            console.error('Error fetching data:', err);
            setError(err.response?.data?.message || 'Error fetching data');
        } finally {
            setLoading(false);
        }
    };

    const fetchStaffData = async () => {
        try {
            setLoading(true);
            setError(null);
            setHasSubmitted(true);

            const response = await makeApiRequest('post', '/api/learning/staff', {
                token: localStorage.getItem('authToken'),
                data: {
                    start_date: startDate,
                    end_date: endDate,
                    location: userLocation ? userLocation : location,
                    name: (control == 2 && userName) ? userName : staffName,
                },
                page: page + 1,
                per_page: rowsPerPage
            });

            if (response.status === 'success') {
                setLearningData(response.data.data);


                const pagination = response.data.pagination || {};
                setTotalPages(pagination.last_page || Math.ceil(response.data.data.length / rowsPerPage));
                setTotalRecords(pagination.total || response.data.data.length);
            } else {
                setLearningData([]);
                throw new Error('Invalid data received');
            }
        } catch (err) {
            console.error('Error fetching data:', err);
            setError(err.response?.data?.message || 'Error fetching data');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchStaffData();
    }, [page, rowsPerPage]);

    const handleChange = async (event, newValue) => {
        setHasSubmitted(false);
        if (control == 2) {
            setLocation(userLocation);
            setStaffName(userName);
            setStartDate("");
            setEndDate("");
            fetchStaffData();
        }
        if (newValue == 'today') {
            setStartDate(today_date);
            setEndDate(today_date);
            fetchStaffDataToday()
        }
        else if (newValue === "historical") {
            setPage(0);
        }
        else if (control == 1) {
            setStartDate("");
            setEndDate("");
            setLocation("");
            setStaffName("");
        }
        setValue(newValue);
        setLearningData([]);
    };

    const handleSubmit = async () => {
        try {
            if (value === 'historical') {
                if (startDate === '' || endDate === '') {
                    toast.warn("Please choose start date and end date");
                    return;
                }
            }

            setLoading(true);
            setError(null);
            setPage(0);
            setHasSubmitted(true);

            const response = await makeApiRequest('post', '/api/learning/staff', {
                token: localStorage.getItem('authToken'),
                data: {
                    start_date: startDate,
                    end_date: endDate,
                    location: (control == 2 && userLocation) ? userLocation : location,
                    name: userName ? userName : staffName,
                },
                per_page: rowsPerPage,
                page: 1,
            });

            if (response.status === 'success') {
                const data = response.data.data || [];
                setLearningData(data);

                const pagination = response.data.pagination || {};
                setTotalPages(pagination.last_page || Math.ceil(data.length / rowsPerPage));
                setTotalRecords(pagination.total || data.length);
            } else {
                setLearningData([]);
                throw new Error('Invalid data received');
            }
        } catch (err) {
            console.error('Error fetching data:', err);
            setError(err.response?.data?.message || 'Error fetching data');
        } finally {
            setLoading(false);
        }
    };

    const handleLocationChange = async (event) => {
        setLocation(event.target.value);

        try {
            const response = await makeApiRequest('post', '/api/staff/list_view', {
                location: event.target.value,
                token: localStorage.getItem('authToken'),
            });

            if (response.status === 'success') {
                setStaffList(response.data);
            } else {
                throw new Error('Failed to fetch staff list');
            }
        } catch (err) {
            console.error('Error fetching staff list:', err);
            setError(err.response?.data?.message || 'Error fetching staff list');
        }
    };

    const handleStaffChange = (event) => {
        setStaffName(event.target.value);
    }

    const getFilteredData = (learningData) => {
        if (!searchText || !Array.isArray(learningData)) return learningData;

        return learningData.filter(item => {
            const searchLower = searchText.toLowerCase();
            return (
                (String(item.name || '').toLowerCase().includes(searchLower)) ||
                (String(item.user_id || '').toLowerCase().includes(searchLower)) ||
                (String(item.location || '').toLowerCase().includes(searchLower)) ||
                (String(item.task || '').toLowerCase().includes(searchLower)) ||
                (String(item.desc || '').toLowerCase().includes(searchLower)) ||
                (formatDate(item.date || '').toLowerCase().includes(searchLower)) ||
                (trimSeconds(item.in_time || '').toLowerCase().includes(searchLower)) ||
                (trimSeconds(item.out_time || '').toLowerCase().includes(searchLower)) ||
                (formatTimeToHoursMinutes(item.duration || '').toLowerCase().includes(searchLower))
            );
        });
    };

    const fetchAllStaffData = async () => {
        try {
            const response = await makeApiRequest('post', '/api/learning/staff/all', {
                token: localStorage.getItem('authToken'),
                data: {
                    start_date: startDate,
                    end_date: endDate,
                    location: userLocation ? userLocation : location,
                    name: (control == 2 && userName) ? userName : staffName,
                }
            });

            if (response.status === 'success') {
                return response.data.data || [];
            } else {
                throw new Error('Invalid data received');
            }
        } catch (err) {
            console.error('Error fetching all data:', err);
            toast.error('Error fetching data for export');
            return [];
        }
    };

    const handleExport = async () => {
        const data = await fetchAllStaffData();
        if (!data || data.length === 0) {
            toast.warn("No data available to export.");
            return;
        }

        const doc = new jsPDF();
        const title = value === "today" ? "Staff Task Report (Today)" : "Staff Task Report (Historical)";
        doc.setFontSize(16);
        doc.setFont("helvetica", "bold");
        doc.text(title, 14, 15);

        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 22);

        const headers = [["Staff Name", "Date", "Duration", "Task", "Description"]];
        const body = data.map(item => [
            `${item.name || '-'} (${item.location || 'Unknown'} | ${item.user_id || '-'})`,
            formatDate(item.date) || '-',
            `${formatTimeToHoursMinutes(item.duration) || '-'} (${trimSeconds(item.in_time) || '-'} to ${trimSeconds(item.out_time) || '-'})`,
            item.task || '-',
            item.desc || '-'
        ]);

        doc.autoTable({
            startY: 30,
            head: headers,
            body: body,
            theme: 'grid',
            styles: {
                font: 'helvetica',
                fontSize: 10,
                cellPadding: 3,
                textColor: [0, 0, 0],
                lineColor: [200, 200, 200],
                lineWidth: 0.1
            },
            headStyles: {
                fillColor: [70, 130, 180],
                textColor: [255, 255, 255],
                fontStyle: 'bold',
                halign: 'center'
            },
            alternateRowStyles: {
                fillColor: [245, 245, 245]
            },
            columnStyles: {
                0: { cellWidth: 50 }, // Staff Name
                1: { cellWidth: 30 }, // Date
                2: { cellWidth: 40 }, // Duration
                3: { cellWidth: 30 }, // Task
                4: { cellWidth: 40 }  // Description
            },
            margin: { top: 30, left: 14, right: 14 }
        });

        doc.save(`${value === "today" ? "today" : "historical"}-staff-task-report.pdf`);
    };

    const handleExportExcel = async () => {
        const data = await fetchAllStaffData();
        if (!data || data.length === 0) {
            toast.warn("No data available to export.");
            return;
        }

        const headers = ["Staff Name", "Date", "Duration", "Task", "Description"];
        const worksheetData = [
            headers,
            ...data.map(item => [
                `${item.name || '-'} (${item.location || 'Unknown'} | ${item.user_id || '-'})`,
                formatDate(item.date) || '-',
                `${formatTimeToHoursMinutes(item.duration) || '-'} (${trimSeconds(item.in_time) || '-'} to ${trimSeconds(item.out_time) || '-'})`,
                item.task || '-',
                item.desc || '-'
            ])
        ];

        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();

        // Apply styling to headers
        worksheet['!cols'] = [
            { wch: 40 }, // Staff Name
            { wch: 15 }, // Date
            { wch: 30 }, // Duration
            { wch: 20 }, // Task
            { wch: 30 }  // Description
        ];

        // Bold headers
        headers.forEach((_, index) => {
            const cell = XLSX.utils.encode_cell({ r: 0, c: index });
            worksheet[cell].s = {
                font: { bold: true },
                fill: { fgColor: { rgb: "4682B4" } },
                color: { rgb: "FFFFFF" },
                alignment: { horizontal: "center" }
            };
        });

        XLSX.utils.book_append_sheet(workbook, worksheet, "Staff Task Report");
        XLSX.writeFile(workbook, `${value === "today" ? "today" : "historical"}-staff-task-report.xlsx`);
    };


    const convertDurationToMinutes = (duration) => {
        if (!duration) return 0;
        const [hours, minutes] = duration.split(':').map(Number);
        return (hours * 60) + minutes;
    }
    const getPaginatedData = () => {
        if (!Array.isArray(learningData)) {
            return [];
        }
        const filteredData = getFilteredData(learningData);
        const startIndex = page * rowsPerPage;
        const endIndex = startIndex + rowsPerPage;
        return filteredData.slice(startIndex, endIndex);
    };

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const getSortIcon = (field) => {
        if (sortConfig.key === field) {
            return sortConfig.direction === 'asc' ?
                <ArrowUpwardIcon sx={{ fontSize: 16, verticalAlign: 'middle', ml: 1 }} /> :
                <ArrowDownwardIcon sx={{ fontSize: 16, verticalAlign: 'middle', ml: 1 }} />;
        }
        return null;
    };

    const getSortedData = (data) => {
        if (!sortConfig.key || !Array.isArray(data)) return data;

        return [...data].sort((a, b) => {
            let aValue, bValue;

            switch (sortConfig.key) {
                case 'staffName':
                    aValue = (a.staffName || a.name || '').toLowerCase();
                    bValue = (b.staffName || b.name || '').toLowerCase();
                    break;
                case 'date':
                    aValue = new Date(a.date);
                    bValue = new Date(b.date);
                    break;
                case 'duration':
                    aValue = convertDurationToMinutes(a.duration);
                    bValue = convertDurationToMinutes(b.duration);
                    break;
                default:
                    aValue = a[sortConfig.key];
                    bValue = b[sortConfig.key];
            }

            if (aValue < bValue) {
                return sortConfig.direction === 'asc' ? -1 : 1;
            }
            if (aValue > bValue) {
                return sortConfig.direction === 'asc' ? 1 : -1;
            }
            return 0;
        });
    };

    const SortableTableCell = ({ field, label }) => (
        <TableCell
            onClick={() => handleSort(field)}
        >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <strong>{label}</strong>
                {sortConfig.key === field && (
                    sortConfig.direction === 'asc' ?
                        <ArrowUpwardIcon sx={{ fontSize: 16, marginLeft: 1 }} /> :
                        <ArrowDownwardIcon sx={{ fontSize: 16, marginLeft: 1 }} />
                )}
            </Box>
        </TableCell>
    );

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setPage(0);
    };
    if (loading) return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="400px"
        >
            <CircularProgress
                size={40}
                thickness={4}
                sx={{
                    color: '#481E82',
                }}
            />
        </Box>
    );


    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />
            <Box sx={{ minHeight: '100vh', backgroundColor: '#ECEDFF', width: "100%", maxHeight: 'auto' }}>
                <Container maxWidth='xl'>
                    <Grid Container spacing={2}>
                        <Grid item xs={12} style={{ height: "80px", display: "flex", alignItems: "center" }}>
                            {control == 1 && (
                                <Typography
                                    variant="h3"
                                    sx={{
                                        fontFamily: "Roboto",
                                        fontSize: { xs: '24px', sm: "34px" },
                                        fontStyle: "normal",
                                        fontWeight: "500",
                                        lineHeight: "160%",
                                        letterSpacing: "0.15px",
                                        color: "#481E82",
                                        // paddingLeft: '15px'
                                    }}
                                >
                                    View Staff Tasks
                                </Typography>
                            )}
                            {control == 2 && (
                                <Typography
                                    variant="h3"
                                    sx={{
                                        fontFamily: "Roboto",
                                        fontSize: { xs: '24px', sm: "34px" },
                                        fontStyle: "normal",
                                        fontWeight: "500",
                                        lineHeight: "160%",
                                        letterSpacing: "0.15px",
                                        color: "#481E82",
                                        // paddingLeft: '15px'
                                    }}
                                >
                                    My Tasks
                                </Typography>

                            )}

                        </Grid>

                        <Grid item xs={12}>
                            <Box
                            // sx={{
                            //     display: "flex",
                            //     justifyContent: "center",
                            // }}
                            >
                                <Card sx={{ display: "flex", justifyContent: { xs: 'flex-start', sm: "flex-start" }, alignItems: "center", height: "100%" }}>
                                    <Tabs
                                        value={value}
                                        onChange={handleChange}
                                        aria-label="centered tabs example"
                                        centered
                                    >
                                        <Tab label="Today" value='today' sx={{ fontWeight: value === 'today' ? 'bold' : 'normal' }} />
                                        <Tab label="Historical" value='historical' sx={{ fontWeight: value === 'historical' ? 'bold' : 'normal' }} />
                                    </Tabs>
                                </Card>
                            </Box>
                        </Grid>

                        <Grid item xs={12}>
                            {value === 'today' && (
                                <Grid container spacing={2} sx={{ paddingLeft: 0, paddingRight: 0, marginTop: "1px" }}>
                                    {(control == 1 || control == 4) && (
                                        <Grid item xs={12}>
                                            <Card sx={{
                                                px: 2, py: 3
                                            }}>
                                                <Grid container spacing={2} >
                                                     <Grid item xs={12} sm={7}>
                                                         <Grid container spacing={2}>
                                                             {control == 1 && (
                                                                 <Grid item xs={12} sm={6} md={6} lg={5}>
                                                                     <FormControl
                                                                         fullWidth
                                                                         sx={{ maxWidth: "100%" }}
                                                                         size="small"
                                                                     >
                                                                         <InputLabel id="dropdown-label"
                                                                         >
                                                                             Select Location
                                                                         </InputLabel>
                                                                         <Select
                                                                             labelId="dropdown-label"
                                                                             id="dropdown"
                                                                             value={location}
                                                                             onChange={handleLocationChange}
                                                                             label="Select Location"

                                                                         >
                                                                             <MenuItem value="All Locations">All Locations</MenuItem>
                                                                             {locations && locations.map((loc) => (
                                                                                 <MenuItem key={loc.id} value={loc.primary_location}>
                                                                                     {loc.primary_location}
                                                                                 </MenuItem>
                                                                             ))}
                                                                         </Select>
                                                                     </FormControl>
                                                                 </Grid>
                                                             )}
                                                             {control == 4 && (
                                                                 <Grid item xs={12} sm={6} md={6} lg={5}>
                                                                     <TextField
                                                                         fullWidth
                                                                         sx={{ maxWidth: "100%" }}
                                                                         size="small"
                                                                         value={location}
                                                                         disabled
                                                                         label="Location"
                                                                     />
                                                                 </Grid>
                                                             )}
                                                             {(control == 1 || control == 4) && (
                                                                 <Grid item xs={12} sm={6} md={6} lg={5}>
                                                                     <FormControl
                                                                         fullWidth
                                                                         sx={{ maxWidth: "100%" }}
                                                                         size="small"
                                                                     >
                                                                         <InputLabel id="dropdown-label"
                                                                         >Select staff</InputLabel>
                                                                         <Select
                                                                             labelId="dropdown-label"
                                                                             id="dropdown"
                                                                             value={staffName}
                                                                             onChange={handleStaffChange}
                                                                             label="Select staff"
                                                                         >
                                                                             <MenuItem value="">All Staffs</MenuItem>
                                                                             {staffList.map((staffMember, index) => (
                                                                                 <MenuItem key={index} value={staffMember.userid}>
                                                                                     {staffMember.name}
                                                                                 </MenuItem>
                                                                             ))}
                                                                         </Select>
                                                                     </FormControl>
                                                                 </Grid>
                                                             )}
                                                         </Grid></Grid>

                                                    <Grid item xs={12} sm={5} sx={{ display: "flex", justifyContent: "flex-end" }}>
                                                        <Button
                                                            variant="contained"
                                                            onClick={handleSubmit}
                                                            size='medium'
                                                            sx={{
                                                                // height: { xs: '45px', md: '50px' },
                                                                // width: { xs: "100%", md: "auto" },
                                                                // marginTop: { xs: "10px", sm: "0" }
                                                            }}
                                                        >
                                                            Submit
                                                        </Button>
                                                        {/* </Box> */}
                                                        {/* </Grid> */}
                                                    </Grid>


                                                </Grid>
                                            </Card>
                                        </Grid>
                                    )}
                                </Grid >
                            )}
                            {
                                value === 'historical' && (
                                    <Grid container spacing={2} sx={{ paddingLeft: 0, paddingRight: 0, marginTop: "0" }}>
                                        <Grid item xs={12}>
                                            <Card sx={{ padding: 2, height: "auto" }}>
                                                <Grid container spacing={2} sx={{ marginTop: '10px' }}>
                                                    <Grid item xs={12} sm={3}>
                                                        <TextField
                                                            label="Start Date "
                                                            type="date"
                                                            variant="outlined"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            size='small'
                                                            sx={{
                                                                width: "100%",
                                                                "& input": {
                                                                    color: startDate ? "#000" : "#a2a2a2", // Black when selected, Gray when empty
                                                                },
                                                                "& input::-webkit-datetime-edit-text": {
                                                                    color: "#a2a2a2", // Gray placeholder (dd-mm-yyyy)
                                                                },
                                                                "& input::-webkit-datetime-edit-year-field, \
                                                                   & input::-webkit-datetime-edit-month-field, \
                                                                   & input::-webkit-datetime-edit-day-field": {
                                                                    color: startDate ? "#000" : "#a2a2a2", // Black when selected
                                                                }
                                                            }}
                                                            value={startDate}
                                                            onChange={(event) => {
                                                                setStartDate(event.target.value);

                                                            }}
                                                            onFocus={(e) => e.target.showPicker()}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={3}>
                                                        <TextField
                                                            label="End Date"
                                                            type="date"
                                                            variant="outlined"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            size='small'
                                                            sx={{
                                                                width: "100%",
                                                                "& input": {
                                                                    color: endDate ? "#000" : "#a2a2a2", // Black when selected, Gray when empty
                                                                },
                                                                "& input::-webkit-datetime-edit-text": {
                                                                    color: "#a2a2a2", // Gray placeholder (dd-mm-yyyy)
                                                                },
                                                                "& input::-webkit-datetime-edit-year-field, \
                                                                   & input::-webkit-datetime-edit-month-field, \
                                                                   & input::-webkit-datetime-edit-day-field": {
                                                                    color: endDate ? "#000" : "#a2a2a2", // Black when selected
                                                                }
                                                            }}
                                                            value={endDate}
                                                            onChange={(event) => {
                                                                setEndDate(event.target.value);
                                                            }}
                                                            onFocus={(e) => e.target.showPicker()}
                                                        />
                                                    </Grid>
                                                    {(control == 2) && (
                                                        <Grid item xs={12} sm={6}
                                                            sx={{ display: "flex", justifyContent: "flex-end" }}>
                                                            <Button variant="contained" onClick={handleSubmit}>
                                                                Submit
                                                            </Button>
                                                        </Grid>
                                                    )}
                                                    {(control == 1 || control == 4) && (
                                                        <Grid item xs={12} sm={3}>
                                                            {control == 1 && (
                                                                <FormControl
                                                                    fullWidth
                                                                    sx={{ maxWidth: "100%" }}
                                                                    size="small"
                                                                >
                                                                    <InputLabel id="dropdown-label"
                                                                    >
                                                                        Select Location
                                                                    </InputLabel>
                                                                    <Select
                                                                        labelId="dropdown-label"
                                                                        id="dropdown"
                                                                        value={location}
                                                                        onChange={handleLocationChange}
                                                                        label="Select Location"

                                                                    >
                                                                        <MenuItem value="All Locations">All Locations</MenuItem>
                                                                        {locations && locations.map((loc) => (
                                                                            <MenuItem key={loc.id} value={loc.primary_location}>
                                                                                {loc.primary_location}
                                                                            </MenuItem>
                                                                        ))}
                                                                    </Select>
                                                                </FormControl>
                                                            )}
                                                            {control == 4 && (
                                                                <TextField
                                                                    fullWidth
                                                                    sx={{ maxWidth: "100%" }}
                                                                    size="small"
                                                                    value={location}
                                                                    disabled
                                                                    label="Location"
                                                                />
                                                            )}
                                                        </Grid>
                                                    )}
                                                    {(control == 1 || control == 4) && (
                                                        <Grid item xs={12} sm={3}>
                                                            <FormControl
                                                                fullWidth
                                                                sx={{ maxWidth: "100%" }}
                                                                size="small"
                                                            >
                                                                <InputLabel id="dropdown-label"
                                                                >Select staff</InputLabel>
                                                                <Select
                                                                    labelId="dropdown-label"
                                                                    id="dropdown"
                                                                    value={staffName}
                                                                    onChange={handleStaffChange}
                                                                    label="Select staff"
                                                                >
                                                                    <MenuItem value="">All Staffs</MenuItem>
                                                                    {staffList.map((staffMember, index) => (
                                                                        <MenuItem key={index} value={staffMember.userid}>
                                                                            {staffMember.name}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                            </FormControl>
                                                        </Grid>
                                                    )}
                                                </Grid>
                                                {(control == 1 || control == 4) && (
                                                    <Box sx={{ display: "flex", justifyContent: { xs: 'center', sm: "flex-end" }, marginTop: 3 }}>
                                                        <Button variant="contained" size="medium" onClick={handleSubmit}>
                                                            Submit
                                                        </Button>
                                                    </Box>
                                                )}
                                            </Card>
                                        </Grid>
                                    </Grid>
                                )
                            }
                        </Grid>


                        <Grid item xs={12}>
                            <Box
                                sx={{
                                    // display: "flex",
                                    // justifyContent: "center",
                                    // alignItems: "center",
                                    // padding: 1,
                                    mt: 1
                                }}
                            >
                                <Box
                                    sx={{
                                        maxWidth: '100%',
                                        width: '100%',
                                        backgroundColor: 'white',
                                        borderRadius: 1,
                                        boxShadow: 3,
                                        position: 'relative',
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            flexDirection: { xs: 'column', sm: "row" },
                                            padding: '20px 15px'
                                        }}
                                    >
                                        <Grid container spacing={2} sx={{ justifyContent: "space-between" }}>
                                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                                <TextField
                                                    // label="Search"
                                                    value={searchText}
                                                    onChange={(e) => setSearchText(e.target.value)}
                                                    size='small'
                                                    placeholder="Search"
                                                    sx={{ width: /* { xs: "100%", sm: "auto" } */"100%" }}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <Search />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={7} md={6}>
                                                <Grid container spacing={0} sx={{ justifyContent: "flex-end" }}>
                                                    {/* <Grid item xs={12} sm={6} md={5} lg={4.5} xl={3.5} sx={{ display: "flex", justifyContent: "flex-end" }} > */}
                                                    <Button
                                                        variant="contained"
                                                        onClick={handleExport}
                                                        startIcon={<PictureAsPdfIcon />}
                                                        disabled={!learningData.length}
                                                        sx={{
                                                            // backgroundColor: "#4CAF50",
                                                            backgroundColor: "orange",
                                                            // "&:hover": { backgroundColor: "#45A049" },
                                                            // height: "45px",
                                                            width: { xs: "100%", sm: "fit-content" },
                                                            marginRight: { xs: 0, sm: 2 }
                                                        }}>
                                                        Download as PDF
                                                    </Button>
                                                    <Button
                                                        variant="contained"
                                                        onClick={handleExportExcel}
                                                        startIcon={<GridOnIcon />}
                                                        disabled={!learningData.length}

                                                        sx={{
                                                            backgroundColor: "#4CAF50",
                                                            "&:hover": { backgroundColor: "#45A049" },
                                                            // height: "47px",
                                                            width: { xs: "100%", sm: "fit-content" },
                                                            marginTop: { xs: 1, sm: 0 }
                                                        }}
                                                    >
                                                        Export to EXCEL
                                                    </Button>
                                                </Grid>

                                            </Grid>
                                        </Grid>
                                    </Box>


                                    <TableContainer sx={{ width: '100%', overflowX: "auto", marginTop: 0 }}>
                                        <Table /* sx={{ width: "100%", tableLayout: "fixed" }} */>
                                            <TableHead sx={{ backgroundColor: '#f1f4f9' }}>
                                                <TableRow>
                                                    <TableCell sx={{ fontWeight: "bold", color: "black" }}><strong>Staff Name</strong></TableCell>
                                                    <TableCell sx={{ fontWeight: "bold", color: "black" }}><strong>Date</strong></TableCell>
                                                    <TableCell sx={{ fontWeight: "bold", color: "black" }}><strong>Duration</strong></TableCell>
                                                    <TableCell sx={{ fontWeight: "bold", color: "black" }}><strong>Task</strong></TableCell>
                                                    <TableCell sx={{ fontWeight: "bold", color: "black" }}><strong>Description</strong></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody >
                                                {hasSubmitted ? (
                                                    getSortedData(getFilteredData(learningData)).length > 0 ? (
                                                        getSortedData(getFilteredData(learningData)).map((row) => (
                                                            <TableRow key={row.id}>
                                                                <TableCell>
                                                                    {row.staffName || row.name}
                                                                    <br />
                                                                    <Typography variant="body2" sx={{ fontSize: '13px', color: 'gray' }}>
                                                                        {row.location} | {row.staffId || row.user_id}
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell>{formatDate(row.date)}</TableCell>
                                                                <TableCell>
                                                                    {formatTimeToHoursMinutes(row.duration)}
                                                                    <br />
                                                                    <Typography variant="body2" sx={{ fontSize: '13px', color: 'gray' }}>
                                                                        {trimSeconds(row.in_time)} to {trimSeconds(row.out_time)}
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell>{row.task}</TableCell>
                                                                <TableCell>{row.desc}</TableCell>
                                                            </TableRow>
                                                        ))
                                                    ) : (
                                                        <TableRow>
                                                            <TableCell colSpan={5} align="center">
                                                                No data available
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                ) : (
                                                    <TableRow>
                                                        <TableCell colSpan={5} align="center">
                                                            Please click submit to view task data
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    {/* Pagination */}
                                    <TablePagination
                                        component="div"
                                        count={totalRecords}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        rowsPerPage={rowsPerPage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />

                                </Box>
                            </Box>
                        </Grid>

                    </Grid>

                </Container>
            </Box >
        </>
    )
}

export default ViewStaffTask;